import { HTTPError } from 'ky';

export const getHttpErrorMessage = async (
    error: unknown,
    fallback: string,
): Promise<string> => {
    if (error instanceof HTTPError) {
        try {
            const body = await error.response.clone().json();
            if (body?.error && typeof body.error === 'string') {
                return body.error;
            }
            if (body?.message && typeof body.message === 'string') {
                return body.message;
            }
        } catch {
            // ignore parse errors
        }

        if (error.response?.statusText) {
            return `${error.response.status} ${error.response.statusText}`;
        }
    }

    if (error instanceof Error && error.message) {
        return error.message;
    }

    return fallback;
};
